import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { ClassValue } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Regional indicator letters render as the country's flag emoji ('ES' -> 🇪🇸)
export function countryFlag(countryCode: string) {
  if (!/^[a-z]{2}$/i.test(countryCode)) return ''

  return String.fromCodePoint(
    ...[...countryCode.toUpperCase()].map(
      (letter) => 0x1f1e6 + letter.charCodeAt(0) - 65,
    ),
  )
}
